import { PayrollScreen, type PayrollSection } from '@felix/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officePayrollSource } from '../payroll-source.js';
import { useSession } from '../session.js';

/**
 * Crew ▸ Payroll (M16; ADR 0061, ADR 0066): gemiden gelen hesap salt okunur; ödeme, dekont ve
 * mutabakat ofiste. Bölüm menü yaprağından; dekont yüklemesinin devamı kişiye bağlı.
 */
export function PayrollPage({ section }: { section: PayrollSection }) {
  const { t } = useTranslation();
  const owner = useSession().me?.user?.id;
  const source = useMemo(() => officePayrollSource(owner), [owner]);
  return (
    <Shell title={t('payroll.title')}>
      <PayrollScreen
        key={section}
        source={source}
        section={section}
        today={new Date().toISOString().slice(0, 10)}
      />
    </Shell>
  );
}
